module.exports = __webpack_public_path__ + "media/ni_hao_ma.e9abcd33.mp3";